import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { AppEvents, QUERY_KEYS } from 'src/constants'

import { scanService } from 'src/services/scan.service'

export const useDeleteScan = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation((scanId: string) => scanService.deleteScan(scanId), {
    onSuccess(data) {
      if (!data) return

      queryClient.invalidateQueries(QUERY_KEYS.SCANS)
      queryClient.invalidateQueries(QUERY_KEYS.SCANS_STATUS_COUNT)
      queryClient.invalidateQueries([QUERY_KEYS.SCANS_UNREVIEWED_COUNT, accountId || ''])
    },
  })
}
